import i18n from "@/i18n";
import { fromUnixTime, format as _format, formatDistance, getUnixTime as _getUnixTime } from "date-fns";
import cnformatDistance from "date-fns/locale/zh-CN/_lib/formatDistance";
import enformatDistance from "date-fns/locale/en-US/_lib/formatDistance";
import jstz from "jstz";

const formatDistanceMap = {
    cn: cnformatDistance,
    en: enformatDistance
};

export function formatUnixTime(input, config) {
    if (!input) return "--";
    try {
        const from = fromUnixTime(input);
        return format(from, config);
    } catch (err) {
        console.error(err, err.message);
        return "--";
    }
}

export function format(input, { distance = false, format: f = "yyyy-MM-dd HH:mm:ss" } = {}) {
    try {
        if (distance) {
            const now = true === distance ? new Date() : distance;
            return formatDistance(input, now, { locale: { formatDistance: formatDistanceMap[i18n.locale] } });
        }
        return _format(input, f);
    } catch (err) {
        console.error(err, err.message);
        return "--";
    }
}

export function getUnixTime(inputDate = new Date()) {
    return _getUnixTime(inputDate);
}

export function getTimezoneName() {
    const timezone = jstz.determine();
    return timezone.name();
}
